/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  return (
    <>
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>

        <>
          <li className="menu-section ">
            <h4 className="menu-text">AUTHENTICATION</h4>
            <i className="menu-icon flaticon-more-v2"></i>
          </li>

          {/* <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/groups"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/groups">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Groups</span>
            </NavLink>
          </li> */}

          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/users"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/users">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Users</span>
            </NavLink>
          </li>
        </>

        <>
          <li className="menu-section ">
            <h4 className="menu-text">Skinapp</h4>
            <i className="menu-icon flaticon-more-v2"></i>
          </li>

          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/body-care-products"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/body-care-products">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Body Care Products</span>
            </NavLink>
          </li>

          {/* bodyCareStart */}
          {/* <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/error", true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/error">
              <span className="menu-text">Body Care</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <li className="menu-item  menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">Body Care</span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/body-care-products"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/body-care-products">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Body Care Products</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/body-care-links"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/body-care-links">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Body Care Links</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/body-care/secondary-images"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/body-care/secondary-images">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Body Care Secondary Images</span>
                  </NavLink>
                </li>

              </ul>
            </div>
          </li> */}
          {/* bodyCareEnd */}


          {/* SkinCareStart */}
          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/skin-care-products"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/skin-care-products">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Skin Care Products</span>
            </NavLink>
          </li>
          {/* <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/error", true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/error">
              <span className="menu-text">Skin Care</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <li className="menu-item  menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">Skin Care</span>
                  </span>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/skin-care-products"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/skin-care-products">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Skin Care Products</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/skin-care-links"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/skin-care-links">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Skin Care Links</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/skin-conserns"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/skin-conserns">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Skin Conserns</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/skin-care/secondary-images"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/skin-care/secondary-images">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Skin Care Secondary Images</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li> */}
          {/* SkinCareEnd */}


          {/* HairCareStart */}
          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/hair-care-products"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/hair-care-products">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Hair Care Products</span>
            </NavLink>
          </li>

          {/* <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/error", true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/error">
              <span className="menu-text">Hair Care</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <ul className="menu-subnav">
                <li className="menu-item  menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">Hair Care</span>
                  </span>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/hair-care-products"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/hair-care-products">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Hair Care Products</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/hair-care-links"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/hair-care-links">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Hair Care Links</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/hair-conserns"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/hair-conserns">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Hair Conserns</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/hair-care/secondary-images"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/hair-care/secondary-images">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Hair Care Secondary Images</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li> */}
          {/* HairCareEnd */}


          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/brands"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/brands">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Brands</span>
            </NavLink>
          </li>

          {/* <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/secondary-images"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/secondary-images">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Secondary images</span>
            </NavLink>
          </li> */}

          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/vendors"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/vendors">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Vendors</span>
            </NavLink>
          </li>

                    
          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/coupons"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/coupons">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Coupons</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/blog-tags"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/blog-tags">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Blog Tags</span>
            </NavLink>
          </li>

          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/blogs"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/blogs">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Blogs</span>
            </NavLink>
          </li>

          {/* <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/order-items"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/order-items">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Order Items</span>
            </NavLink>
          </li> */}

          {/* <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/orders"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/orders">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Orders</span>
            </NavLink>
          </li> */}

          {/* <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/shipping-address"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/shipping-address">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Shipping Address</span>
            </NavLink>
          </li> */}
          {/* 
          <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/user-profiles"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/user-profiles">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">User Profiles</span>
            </NavLink>
          </li> */}

          {/* <li
            className={`menu-item ${getMenuItemActive(
              "/e-commerce/whishlists"
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/e-commerce/whishlists">
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
              <span className="menu-text">Whishlists</span>
            </NavLink>
          </li> */}

          {/* <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/error", true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/error">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                />
              </span>
              <span className="menu-text">Transactions</span>
              <i className="menu-arrow" />
            </NavLink>
            <div className="menu-submenu ">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item  menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">Transactions</span>
                  </span>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/card-transactions"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/card-transactions">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Card Transactions</span>
                  </NavLink>
                </li>


                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/cash-transactions"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/cash-transactions">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Cash Transactions</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/e-commerce/stripe-transactions"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/e-commerce/stripe-transactions">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">Stripe Transactions</span>
                  </NavLink>
                </li>

              </ul>
            </div>
          </li> */}
        </>

      </ul>

    </>
  );
}
